"use client";
import i, { useState as D, useRef as R, useEffect as Y, useMemo as r } from "react";
import "./index.es73.js";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import "./index.es80.js";
import "./index.es81.js";
import { createStatisticsInput as H, createStatisticsSettings as K } from "./index.es82.js";
import $ from "./index.es171.js";
import "./index.es83.js";
import "./index.es84.js";
import "./index.es85.js";
import "./index.es86.js";
import "./index.es87.js";
import "./index.es88.js";
import "./index.es89.js";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import w from "styled-components";
import { getDimensionInfo as J, toUnitDimensionMap as P, getUnitsFromFiltersAndUnitOptions as Q, createDimensionForSettings as X, getImplicitSecondaryLabel as Z, dimensionToChartData as tt, createChartOptionVariablesByType as et } from "./index.es97.js";
import it from "./index.es172.js";
import rt from "./index.es173.js";
import { simpleClone as I } from "./index.es170.js";
import nt from "./index.es174.js";
import at from "./index.es175.js";
import "./index.es176.js";
import ot from "./index.es177.js";
import "./index.es178.js";
import "./index.es179.js";
import "./index.es180.js";
import "./index.es181.js";
import "./index.es182.js";
import "./index.es183.js";
const mt = w.div`
  display: flex;
  justify-content: space-between;
`, st = w.div`
  color: #000000;

  .expander-container {
    display: none;
    min-width: 15rem;
    text-align: right;
    color: #000;

    button {
      padding-right: 0;
    }
    a > i {
      margin-left: 0.5rem;
    }
  }

  @media screen and (min-width: ${$.screenWidths.l}) {
    .expander-container {
      display: block;
    }
    transition: margin 0.3s ease-in-out;

    &.statistics-block--full-screen {
      margin-left: calc(
        (4rem + ${$.containerWidths.medium} - 100vw) / 2
      );
      margin-right: calc(
        (4rem + ${$.containerWidths.medium} - 100vw) / 2
      );
    }
  }
`, Pt = ({
  rootDimension: m,
  rules: c,
  initialSettings: u,
  unitOptions: n,
  chartOptions: f,
  dimensionLabels: p,
  annotations: k,
  group: E,
  groupNames: b,
  groupsTitle: O,
  content: T,
  file: F,
  blockId: o,
  title: s,
  subtitle: N,
  onGroupChange: L
}) => {
  const [e, g] = D(
    I(u)
  ), [y, U] = D(!1), W = R(null);
  Y(() => {
    g(I(u));
  }, [u]);
  const d = r(
    () => J(m),
    [m]
  ), h = r(
    () => d.map((t) => t.name),
    [d]
  ), S = r(
    () => d.map((t) => ({
      name: t.name,
      fieldOptions: t.fields.map((l) => ({ name: l }))
    })),
    [d]
  ), v = r(
    () => P(m, n),
    [m, n]
  ), a = r(
    () => Q(e.filters, n),
    [e.filters, n]
  ), x = r(
    () => v[a] || m,
    [a, v, m]
  ), C = r(
    () => X(x, e),
    [x, e]
  ), j = r(
    () => H(e, c, S, n),
    [e, c, S, n]
  ), B = r(() => {
    const t = a === "Amount", l = !h.includes(e.secondary), M = l ? Z(n, a, s) : void 0;
    return tt(
      C,
      t,
      l,
      M
    );
  }, [
    a,
    h,
    C,
    e,
    p,
    n,
    s
  ]), G = r(() => k.filter(
    (t) => t.primaryDimensionName === e.primary
  ), [k, e.primary]), V = r(
    () => et(
      a,
      s,
      f,
      o,
      p,
      e.primary,
      e.filters,
      n
    ),
    [
      a,
      s,
      f,
      o,
      p,
      e.primary,
      e.filters,
      n
    ]
  ), _ = (t) => {
    g(t);
  }, q = (t) => {
    L(t);
  }, z = (t) => {
    t.preventDefault(), U(!y);
  }, A = !!E && !!b && b.length > 1;
  return /* @__PURE__ */ i.createElement(
    st,
    {
      ref: W,
      className: `bl-tile bl-tile--flat bl-m-b-6 ${y ? "statistics-block--full-screen" : ""}`,
      id: o
    },
    /* @__PURE__ */ i.createElement("div", { className: "bl-container bl-container--small" }, /* @__PURE__ */ i.createElement(mt, null, /* @__PURE__ */ i.createElement("div", null, /* @__PURE__ */ i.createElement("h3", { className: "bl-size-3 bl-p-y-2" }, s)), /* @__PURE__ */ i.createElement("div", { className: "expander-container" }, /* @__PURE__ */ i.createElement(
      ot,
      {
        onClick: (t) => z(t),
        iconName: "expand",
        isSmall: !0,
        styleType: "tertiary"
      },
      y ? "Lukk Fullskjerm" : "Vis Fullskjerm"
    )))),
    N && /* @__PURE__ */ i.createElement("div", { className: "bl-container bl-container--small" }, /* @__PURE__ */ i.createElement("p", { className: "bl-size-5 bl-p-y-2" }, N)),
    A && /* @__PURE__ */ i.createElement(rt, null, /* @__PURE__ */ i.createElement(
      nt,
      {
        blockId: o,
        group: E,
        groupNames: b,
        groupsTitle: O,
        onGroupChange: q
      }
    )),
    /* @__PURE__ */ i.createElement(
      it,
      {
        key: `statistics-block-settings-input-${o}`,
        input: j,
        parentId: `${o}`,
        dimensionLabels: p,
        onValueChange: (t) => {
          const l = K(
            t,
            c,
            h
          );
          g(l);
        }
      }
    ),
    /* @__PURE__ */ i.createElement(
      at,
      {
        blockId: o,
        chartData: B,
        chartOptionVariablesByType: V,
        rules: c,
        settings: e,
        currentUnits: a,
        annotations: G,
        content: T,
        file: F,
        title: s,
        statisticsChartOptions: f,
        dimensionLabels: p,
        onSettingsChange: _
      }
    )
  );
};
export {
  Pt as default
};
//# sourceMappingURL=index.es98.js.map
